// @ts-nocheck
import React from 'react';
import { reactLazyRetry } from '../../utils/Utils';
import { DEFAULT_ROUTE_CONFIG } from '../../const/defaultRoutesConfig';

const BulkUploadListPage = reactLazyRetry(
  () =>
    import('../../features/bulkAction/bulkCreateUpdate/pages/BulkUploadListPage')
);
const BulkUploadCreatePage = reactLazyRetry(
  () =>
    import('../../features/bulkAction/bulkCreateUpdate/pages/BulkUploadCreatePage')
);
const BulkUploadActivityDetailsPage = reactLazyRetry(
  () =>
    import('../../features/bulkAction/bulkCreateUpdate/pages/ActivityDetailsPage')
);
const BulkTransition = reactLazyRetry(
  () => import('./bulkTransition/pages/BulkTransition')
);
const BulkDocumentUpload = reactLazyRetry(
  () => import('./bulkDocumentUpload/pages/BulkDocumentUpload')
);

/**
 * Bulk Actions route definitions and metadata used by the application router
 * and permission-aware navigation (QuickLinks).
 */
export const bulkActionsRoutes = [
  {
    name: 'Bulk Upload',
    key: 'bulkUpload',
    path: DEFAULT_ROUTE_CONFIG?.bulkUpload?.path || 'bulk-upload',
    element: <BulkUploadListPage key="CREATE" operationType="CREATE" />,
    permission: 'BulkActions_bulkUpload',
    quickLink: {
      enabled: true,
      action: 'upload',
    },
    children: [
      {
        name: 'View Activity',
        key: 'bulkUploadActivityDetail',
        path:
          DEFAULT_ROUTE_CONFIG?.bulkUploadActivityDetail?.path ||
          'bulk-upload/activity/:activityId',
        element: (
          <BulkUploadActivityDetailsPage key="CREATE" operationType="CREATE" />
        ),
        permission: 'BulkActions_bulkUpload',
      },
      {
        name: 'Upload',
        key: 'bulkUploadPage',
        path:
          DEFAULT_ROUTE_CONFIG?.bulkUploadPage?.path || 'bulk-upload/upload',
        element: <BulkUploadCreatePage key="CREATE" operationType="CREATE" />,
        permission: 'BulkActions_bulkUpload',
      },
    ],
  },

  {
    name: 'Bulk Transition',
    key: 'bulkTransition',
    path: DEFAULT_ROUTE_CONFIG?.bulkTransition?.path || 'bulk-transition',
    element: <BulkTransition />,
    permission: 'BulkActions_bulkTransition',
    quickLink: {
      enabled: true,
      action: 'list',
    },
  },
  {
    name: 'Bulk Update',
    key: 'bulkUpdate',
    path: DEFAULT_ROUTE_CONFIG?.bulkUpdate?.path || 'bulk-update',
    element: <BulkUploadListPage key="UPDATE" operationType="UPDATE" />,
    permission: 'BulkActions_bulkUpdate',
    quickLink: {
      enabled: true,
      action: 'list',
    },
    children: [
      {
        name: 'View Activity',
        key: 'bulkUpdateActivityDetail',
        path:
          DEFAULT_ROUTE_CONFIG?.bulkUpdateActivityDetail?.path ||
          'bulk-update/activity/:activityId',
        element: (
          <BulkUploadActivityDetailsPage key="UPDATE" operationType="UPDATE" />
        ),
        permission: 'BulkActions_bulkUpdate',
      },
      {
        name: 'Update',
        key: 'bulkUpdatePage',
        path:
          DEFAULT_ROUTE_CONFIG?.bulkUpdatePage?.path || 'bulk-update/update',
        element: <BulkUploadCreatePage key="UPDATE" operationType="UPDATE" />,
        permission: 'BulkActions_bulkUpdate',
      },
    ],
  },

  {
    name: 'Bulk Document Upload',
    key: 'bulkDocumentUpload',
    path: DEFAULT_ROUTE_CONFIG?.bulkDocumentUpload?.path || 'bulk-document',
    element: <BulkDocumentUpload />,
    permission: 'BulkActions_bulkDocumentUpload',
    quickLink: {
      enabled: true,
      action: 'upload',
    },
  },
];
